import { createAction, props } from '@ngrx/store';

export const LoadFederatedLoginWeb = createAction(
  '[Auth] LoadFederatedLoginWeb',
  props<{
    email: string;
    nonce: string;
    state: string;
    redirectUri: string;
    loginSource: 'WEB' | 'MOBILE';
  }>()
);

export const LoadFederatedLoginWebSuccess = createAction(
  '[Auth] LoadFederatedLoginWebSuccess',
  props<{ authenticated: boolean; email: string }>()
);

export const LoadFederatedLoginWebFail = createAction(
  '[Auth] LoadFederatedLoginWebFail',
  props<{ error: Error }>()
);
